module.exports = __webpack_public_path__ + "static/media/user-guide-5.aea3566b.png";